import { AgGridAngular } from 'ag-grid-angular';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { cloneDeep } from 'lodash';
import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CvAngularLoadingOverlayComponent } from 'src/app/reusables/ag-grid-components/cv-angular-loading-overlay/cv-angular-loading-overlay.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { 
  formatCoin,
  getBadgeSize,
  getCellClass,
  getCenterClass,
  getClassIfNotPinned,
  getHeaderCenterClass,
  getHeaderClass,
  getJoinStatusIcon,
  getPassedStatusIcon,
  getRowPinnedClass
} from 'src/app/gamification/command-center/models/games-player-breakdown';
import { GameParticipant } from 'src/AngularJS/Goals/Gamification/Models/game-history';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { GridOptions, GridReadyEvent, GridSizeChangedEvent, RowSelectedEvent } from 'ag-grid-community';
import { HistoricalTeamObj, IHGameStandardize, ParticipantObj } from 'src/app/gamification/command-center/models/games-parameter.model';
@Component({
  selector: 'cv-teams-history-table',
  templateUrl: './teams-history-table.component.html',
  styleUrls: ['./teams-history-table.component.scss']
})
export class TeamsHistoryTableComponent implements OnInit {
  @Input() participants: any;
  @Input() enableSelection: boolean;
  @Input() selectAll: boolean;
  @Input() reversion: boolean;
  @Input() hGame: IHGameStandardize;
  @Input() teamsInfo: { [key: number]: HistoricalTeamObj } = {  };
  @Output() selectedData: EventEmitter<any[]> = new EventEmitter();
  @ViewChild('teamsHistoryTableGrid') agGrid: AgGridAngular;
  @Output() selectedColumns: EventEmitter<any[]> = new EventEmitter();
  @Output() totalRow: EventEmitter<any[]> = new EventEmitter();
  @Output() participantsSorted: EventEmitter<GameParticipant[]> = new EventEmitter();

  gs = null;
  metricFields = null;
  participant = null;
  metric = null;
  qualifier = null;
  results = null;
  rewards = null;
  selectedRows: any[] = [];
  grid: GridOptions = null;
  revertedCoins: number = 0;
  revertedXP: number = 0;

  constructor(
    private gamesService: GamesService,
    private agGridHelperService: AgGridHelperService,
    private metricFormatterPipe: GenericMetricFormatterPipe,
    public cvConfigurationService: CvConfigurationService
  ) {
    this.gs = this.gamesService.data;
    $(document).on('cancelRevertSelection', this.cancelRowSelection);
  }

  ngOnInit(): void {
    //Create grid options
    this.grid = {
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
      },

      accentedSort: true,
      animateRows: true,
      groupDisplayType: 'custom',
      suppressCellFocus: false,
      rowSelection: 'multiple',
      groupSelectsChildren: true,
      suppressDragLeaveHidesColumns: true,
      suppressScrollOnNewData: true,
      suppressRowTransform: true,
      suppressAggFuncInHeader: true,
      columnDefs: this.getColDefs(),
      rowHeight: this.cvConfigurationService.isCxOne ? 36 : undefined,
      headerHeight: this.cvConfigurationService.isCxOne ? 42 : undefined,
      overlayNoRowsTemplate: this.cvConfigurationService.isCxOne
        ? `
            <div class="error-container" style="padding-top: 48px;">
                <svg class="mb-2" style="height: 108px; width: 240px;">
                    <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
                </svg>
                <p class="player-breakdown__grid-empty-state">
                    ${this.gamesService.getGamesHistoryMessages('No_Items_Created_Yet', 'No items created yet')}
                </p>
            </div>`
        : undefined,

      getRowStyle: (params) => {
        if (params.node.rowPinned) {
          return { 'font-weight': 'bold' }
        }
      },

      getRowClass: (params) => {
        return getRowPinnedClass(this.cvConfigurationService.isCxOne, params.node.rowPinned);
      },

      // Sidebar will be included in the full version
      sideBar: this.cvConfigurationService.isCxOne ? false : {
        toolPanels: [{
          id: 'columns',
          labelDefault: this.gamesService.getGamesHistoryMessages('Columns', 'Columns'),
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel'
        }],
        defaultToolPanel: ''
      },

      components: {
        cvAngularLoadingComponent: CvAngularLoadingOverlayComponent,
      },

      rowData: null,
      loadingOverlayComponent: 'cvAngularLoadingComponent',
      getLocaleText: this.agGridHelperService.getLocaleText,

      onGridReady: (e: GridReadyEvent) => {

        let participantsFiltered = [];

        if (this.participants) {
          participantsFiltered = this.participants.filter(p => !!p.participant);
          this.setPinnedData(participantsFiltered);
        } else {
          this.setPinnedData([]);
        }

        if (this.participants && this.participants.length > 0) {
          e.api.setGridOption('rowData', participantsFiltered);
          e.api.autoSizeAllColumns();

          if (this.participants.length > 0) {
            e.api.hideOverlay();
          } else {
            this.grid.noRowsOverlayComponent = null;
            e.api.showNoRowsOverlay();
          }
        }
        if (!this.gs.isLoading && (!this.participants || this.participants.length == 0)) {
          if ((!this.gs.selectedInterval || this.gs.selectedInterval.length == 0) || (this.gs.selectedInterval || this.gs.selectedInterval.length > 0)) {
            this.agGrid?.api?.hideOverlay();
            this.agGrid?.api?.showNoRowsOverlay();
          }
        }
        if (this.agGrid?.columnApi) {
          this.updateSelectedColumns();
        }
        if (this.agGrid?.api && this.agGrid.api?.getPinnedBottomRow(0) && this.agGrid.api.getPinnedBottomRow(0).data) {
          this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
        }
      },

      onRowSelected: (e: RowSelectedEvent) => {
        this.updateSelectedData(e);
      },

      isRowSelectable: (rowNode) => {
        return rowNode.data ? (rowNode.data.calculatedCoins > 0 || rowNode.data.calculatedXP > 0) : false;
      },

      aggFuncs: {
        'metricSum': (params) => {
            if (!this.hGame) return 0;
            const metric = this.hGame.metricDefinition;
            const teamID = params.rowNode.allLeafChildren.find(r => !!r.data.participant)?.data?.participant?.TeamID;
            if (!teamID) return '';
            const team: HistoricalTeamObj = this.teamsInfo[teamID];
            const metricValue = team?.metricsValues?.find(m => m.MetricID === metric?.MetricID);
            return metricValue?.MetricDisplayValue || '---'; // display metric value
        },
        'qualifierSum': (params) => {
          if (!this.hGame) return 0;
          const qualifierMetric = this.hGame.qualifierDefinition;
          const teamID = params.rowNode.allLeafChildren.find(r => !!r.data.participant)?.data?.participant?.TeamID;
          if (!teamID) return '';
          const team: HistoricalTeamObj = this.teamsInfo[teamID];
          const metricValue = team?.metricsValues?.find(m => m.MetricID === qualifierMetric?.MetricID);
          return metricValue?.MetricDisplayValue || '---'; // display metric value
        },
        'countFunc': (params) => {
          let count = 0;
          params.values.forEach((value) => {
            if (value != undefined) {
              count++;
            }
          });

          if (count > 0) {
            return params.values[0];
          } else {
            return count;
          }
        },
        'checkFunc': (params) => {
          let result;
          let count = 0;
          params.values.forEach((value) => {
            if (value) {
              count++;
            }
          });

          if (count > 0) {
            result = true;
          } else {
            result = false;
          }

          return result;
        }
      },

      onGridSizeChanged: (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
      },

      onColumnMoved: () => {
        this.updateSelectedColumns();
      },
      onColumnVisible: () => {
        this.updateSelectedColumns();
      },
      onSortChanged: () => {
        this.updateSelectedColumns();
      },
      postSortRows: (X) => {
        let selectedRowNodesWithSort = [];
        this.agGrid.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data != undefined) selectedRowNodesWithSort.push(node.data);
        });

        this.participantsSorted.emit(cloneDeep(selectedRowNodesWithSort));
      },
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.agGrid && this.agGrid.api) {
      if (changes.participants != undefined && changes.participants.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());

        const participantsFiltered = changes.participants.currentValue.filter(p => !!p.participant);

        this.agGrid.api.setGridOption('rowData', participantsFiltered);

        const sumCoins = participantsFiltered.filter((a) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
        const sumXP = participantsFiltered.filter((a) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
        const sumBadges = participantsFiltered.reduce((sum, current) => sum + current.badges.length, 0);

        this.revertedCoins = participantsFiltered.filter((a) => { return a.calculatedCoins < 0; }).reduce((sum, current) => sum + (current.calculatedCoins), 0);
        this.revertedXP = participantsFiltered.filter((a) => { return a.calculatedXP < 0; }).reduce((sum, current) => sum + (current.calculatedXP), 0);

        const totalPlayers = participantsFiltered.reduce((sum, current) => sum + 1, 0);

        const pinnedData = [{
          calculatedCoins: sumCoins.toLocaleString(CVCultureName),
          calculatedXP: sumXP,
          badges: sumBadges,
          totalPlayers: this.cvConfigurationService.isCxOne ? this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + totalPlayers.toLocaleString(CVCultureName) : null
        }];
        
        this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);

        this.agGrid.api.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();

        if (this.participants.length > 0) {
          this.agGrid?.api?.hideOverlay();
          this.agGrid?.api?.refreshHeader();
        } else {
          this.grid.noRowsOverlayComponent = null;
          this.agGrid?.api?.showNoRowsOverlay();
        }
      } else if (changes.enableSelection != undefined && changes.enableSelection.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', []);
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());
        if (!changes.enableSelection.currentValue) {
          this.cancelRowSelection();
        }

        this.agGrid.api.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();
      } else if (changes.selectAll != undefined) {
        changes.selectAll.currentValue ? this.agGrid?.api?.selectAll() : this.cancelRowSelection();
      } else if (changes.reversion != undefined && changes.reversion.currentValue != null) {
        if (changes.reversion.currentValue) {
          this.selectedData.emit(this.selectedRows);
        }
      } else {
        this.agGrid?.api?.showLoadingOverlay();
      }
      const columnState =this.agGrid?.api?.getColumnState();
      this.selectedColumns.emit(columnState);
      const pinnedBottomRow = this.agGrid.api.getPinnedBottomRow(0);
      if (pinnedBottomRow && pinnedBottomRow.data) {
        this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
      }
    }
  }

  updateSelectedColumns(): void {
    this.selectedColumns.emit(this.agGrid.columnApi.getColumnState());
  }

  updateSelectedData(e: RowSelectedEvent): void {
    if (e.node.isSelected() && e.node.data != undefined) {
      this.selectedRows.push(e.node.data);
    } else {
      var index = this.selectedRows.indexOf(e.node.data);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  setNameColumnValue(params: any): any {
    //If is the team name
    if (params.data == undefined) {
      //If the revert controls are enabled and the team have payments that can't be reverted, a left magin and padding are included to align this group with the other that have the checkbox input
      if (!params.node.selectable && this.enableSelection) {
        return `<div class="ml-4 pl-1" style="cursor: pointer;"><span class="${this.cvConfigurationService.isCxOne ? 'teams-color' : 'color-cerulean'}">` + params.value + `</span></div>`;
      } else {
        return `<div style="cursor: pointer;"><span class="${this.cvConfigurationService.isCxOne ? 'teams-color' : 'color-cerulean'}">` + params.value + `</span></div>`;
      }
    }

    if (params.value !== undefined) {
      //If is a single participant
      let $productContainer = $('<div>').addClass('d-flex');

      if (!this.cvConfigurationService.isCxOne) {
        //Image profile
        let imageId = params.data && params.data.ImageID > 0 ? params.data.ImageID : "";
        let $img = $('<img>').addClass('mr-2').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);
        $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=${imageId}&w=auto&h=25`);
        $img.on('error', () => $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=&w=auto&h=26`));
      }

      //Participant name
      $('<span>').text(params.value).appendTo($productContainer)

      return $productContainer[0];
    }

    return;
  }

  cancelRowSelection(): void {
    if (this.grid != null) {
      this.agGrid?.api?.deselectAll();
      this.selectedRows = [];
    }
  }

  getColDefs(): any {
    let resultsArray = [];

    let participant = {
      headerName: this.gamesService.getGamesHistoryMessages('Player', 'Player'),
      headerClass: params => {
        return [getHeaderClass(this.cvConfigurationService.isCxOne), this.cvConfigurationService.isCxOne ? 'player-breakdown__player-header header-players' : '']
      },
      children: [{
        headerName: 'Team',
        field: 'participant.Team',
        rowGroup: true,
        hide: true,
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if (!params.data.hasOwnProperty('participants')) {
            return params.value;
          } else {
            return params.data.participants;
          }
        }
      }, {
        headerName: this.gamesService.getGamesHistoryMessages('Name', 'Name'),
        field: 'participant.LoginName',
        showRowGroup: true,
        filter: 'agTextColumnFilter',
        cellRenderer: 'agGroupCellRenderer',
        minWidth: 245,
        headerClass: params => {
            return [getHeaderClass(this.cvConfigurationService.isCxOne), this.cvConfigurationService.isCxOne ? 'header-players' : '']
          },
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        cellRendererParams: {
          suppressCount: true,
          checkbox: this.enableSelection,
          innerRenderer: (params) => {
            if (!params.data?.participant && this.cvConfigurationService.isCxOne && params.data?.totalPlayers !== undefined) {
                return params.data.totalPlayers ?? '';
            }
            return this.setNameColumnValue(params);
          }
        }
      }, {
        field: 'participant.AlreadyJoined',
        headerName: this.gamesService.getGamesHistoryMessages('Player_Joined', 'Joined?'),
        aggFunc: 'first',
        headerClass: () => [getHeaderClass(this.cvConfigurationService.isCxOne), getHeaderCenterClass(this.cvConfigurationService.isCxOne)],
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCenterClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if (params.value === undefined || params.value === null)
            return '';

          //Because is the game is has autojoin, will be display always checkmark
          const approve = getJoinStatusIcon(this.gs.selectedGame, true, this.cvConfigurationService.isCxOne);
          return approve;
        },
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
        hide: this.cvConfigurationService.isCxOne
      }]
    }

    let joined = null;
    joined = {
      field: 'participant.AlreadyJoined',
      headerName: this.gamesService.getGamesHistoryMessages('Player_Joined', 'Joined?'),
      aggFunc: 'first',
      headerClass: () => [getHeaderClass(this.cvConfigurationService.isCxOne), getHeaderCenterClass(this.cvConfigurationService.isCxOne)],
      cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCenterClass(this.cvConfigurationService.isCxOne)),
      cellRenderer: (params) => {
        if (params.value === undefined || params.value === null)
        return '';

        //Because is the game is has autojoin, will be display always checkmark
        const approve = getJoinStatusIcon(this.gs.selectedGame, true, this.cvConfigurationService.isCxOne);
        return approve;
      },
      width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      hide: !this.cvConfigurationService.isCxOne
    };

    if (this.participants != null && !this.cvConfigurationService.isCxOne) {
      participant.headerName += ' (' + this.participants.length + ' ' + this.gamesService.getGamesHistoryMessages("Participants", "Participants") + ')';
    }

    resultsArray.push(participant);

    if (this.cvConfigurationService.isCxOne) {
      resultsArray.push(joined);
    }

    if (this.hGame) {
      const metricValue = this.hGame.metricDefinition;

      let metric = {
        headerName: this.gamesService.getGamesHistoryMessages('Metric_Total', 'Metric Total'),
        groupId: 'metricTotalsGroup',
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        children: [{
          field: 'metric',
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
          cellRenderer: (params) => {
            if (params.value === undefined || params.value === null)
              return '';
            return params.value;
          },
          aggFunc: 'metricSum',
          headerValueGetter: params => {
            if (metricValue) {
              return metricValue.MetricDetail?.Name;
            }
            return '--';
          }
        }]
      };
      resultsArray.push(metric);
    }

    if (this.hGame) {
      const qualifierMetric = this.hGame.qualifierDefinition;

      let qualifier = {
        headerName: this.gamesService.getGamesHistoryMessages('Qualifier_Metric', 'Qualifier Metric'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        children: [{
          field: 'qualifier',
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
          headerValueGetter: params => {
            if (qualifierMetric) {
              return qualifierMetric.MetricDetail ? qualifierMetric.MetricDetail.Name : this.gamesService.getGamesHistoryMessages('None', 'None');
            }
            return '--';
          },
          cellRenderer: (params) => {
            return params.value;
          },
          aggFunc: 'qualifierSum'
        }, {
          field: 'passed',
          headerName: this.gamesService.getGamesHistoryMessages('Player_Passed', 'Passed?'),
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCenterClass(this.cvConfigurationService.isCxOne)),
          width: 150,
          cellRenderer: (params) => {
            if (params.value === undefined)
              return '';
  
            const approve = getPassedStatusIcon(qualifierMetric.MetricDetail, params.value, this.cvConfigurationService.isCxOne);
            return approve;
          },
          aggFunc: 'checkFunc',
          filterParams: {
            cellRenderer: (params) => {
              if (params.value === undefined)
                return '';

              const approve = getPassedStatusIcon(qualifierMetric.MetricDetail, JSON.parse(params.value.toLowerCase()), this.cvConfigurationService.isCxOne);
              return approve;
            }
          }
        }]
      };
  
      if (qualifierMetric) resultsArray.push(qualifier);
    }

    let results = {
      headerName: "",
      children: [{
        field: 'results',
        headerName: this.gamesService.getGamesHistoryMessages('Results', 'Results'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        aggFunc: 'first',
        cellRenderer: (params) => {
          if (params.value === undefined || params.value === null)
            return '';

          if (this.hGame) {
            return params.value ? params.value : '';
          }
        }
      }]
    };

    //if multiplier madness, don't include results column
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].GameType != 1) {
      resultsArray.push(results);
    }

    let rewards = {
      headerName: this.cvConfigurationService.isCxOne
        ? this.gamesService.getGamesHistoryMessages('Rewards_Label', 'Rewards')
        : this.gamesService.getGamesHistoryMessages('Reward', 'Reward'),
      headerClass:getHeaderClass(this.cvConfigurationService.isCxOne),
      children: [{
        field: 'calculatedCoins',
        headerName: this.gamesService.getGamesHistoryMessages('Coins', 'Coins'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum',
        cellRenderer: (params) => {
          let isTotalsRow = params.data !== undefined && params.data.participant === undefined;

          if (!isTotalsRow)
            return formatCoin(this.cvConfigurationService.isCxOne, params.value);
          else
            return this.formatPinnedValue('coin', params.value);
        },
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      }, {
        field: 'calculatedXP',
        headerName: this.gamesService.getGamesHistoryMessages('XP', 'XP'),
        filter: 'agNumberColumnFilter',
        width: 175,
        aggFunc: 'sum',
        cellRenderer: (params) => {
          let isTotalsRow = params.data !== undefined && params.data.participant === undefined;

          if (!isTotalsRow)
            return params.value;
          else
            return String(params.value) + " (" + this.revertedCoins + ") " + this.gamesService.getGamesHistoryMessages('XP', 'XP');
        },
        hide: this.cvConfigurationService.isCxOne
      }, {
        field: 'badges',
        headerName: this.cvConfigurationService.isCxOne
          ? this.gamesService.getGamesHistoryMessages('Badge_Label', 'Badge')
          : this.gamesService.getGamesHistoryMessages('Badges', 'Badges'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if (typeof params.value === 'undefined')
            return '';

          if (params.value.length > 0) {
            let badge = `<img src="../Admin/ImageResizer.aspx?imgid=${params.value[0]}&w=${getBadgeSize(this.cvConfigurationService.isCxOne)}&h=${getBadgeSize(this.cvConfigurationService.isCxOne)}" class="img-fluid"/>`;

            return badge;
          } else if (typeof params.value === 'number' && !params.node.group) {
            //To display in totals row
            return `${this.formatPinnedValue('badge', params.value)} ${this.cvConfigurationService.isCxOne ? '' : this.gamesService.getGamesHistoryMessages('Badges_Awarded', 'Badges Awarded')}`;
          } else {
            return '---'
          }
        },
        aggFunc: 'countFunc',
        filterParams: {
          cellRenderer: (params) => {
            return params.value;
          }
        },
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      }]
    };
    resultsArray.push(rewards);

    let payment = {
      headerName: this.gamesService.getGamesHistoryMessages('Payment', 'Payment'),
      headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
      width: 250,
      children: [{
        field: 'paymentDate',
        tooltipField: 'paymentDate',
        headerName: this.cvConfigurationService.isCxOne
          ? this.gamesService.getGamesHistoryMessages('Payment_Results', 'Payment Results')
          : this.gamesService.getGamesHistoryMessages('Payment_Info', 'Payment Information'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        aggFunc: 'first',
        filterParams: {
          cellRenderer: (params) => {
            return params.value;
          }
        },
        cellRenderer: (params) => {
          if (params.data !== undefined) {
            return '';
          } else if (params.value === undefined || params.value === null || params.value.length == 0) {
            return '---';
          } else {
            return params.value;
          }
        }
      }]
    };
    resultsArray.push(payment);

    return resultsArray;
  }

  /**
 * Function to set the pinned data at the bottom of the grid.
 * @param participants - The participants data to be displayed in the bottom grid.
 */
  setPinnedData(participants: any[]): void {

    const participantsFiltered = participants.filter(p => !!p.participant);

    const sumCoins = participantsFiltered.filter((a) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
    const sumXP = participantsFiltered.filter((a) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
    const sumBadges = participantsFiltered.reduce((sum, current) => sum + current.badges.length, 0);

    this.revertedCoins = participantsFiltered.filter((a) => { return a.calculatedCoins < 0; }).reduce((sum, current) => sum + (current.calculatedCoins), 0);
    this.revertedXP = participantsFiltered.filter((a) => { return a.calculatedXP < 0; }).reduce((sum, current) => sum + (current.calculatedXP), 0);

    const totalPlayers = participantsFiltered.reduce((sum, current) => sum + 1, 0);

    const pinnedData = [{
      calculatedCoins: sumCoins.toLocaleString(CVCultureName),
      calculatedXP: sumXP.toLocaleString(CVCultureName),
      badges: sumBadges,
      totalPlayers: this.cvConfigurationService.isCxOne ? this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + totalPlayers.toLocaleString(CVCultureName) : null
    }];

    this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);
  }

  displayReversionValue(value: any): string {
    let resultRev: string = value != 0 ? " (" + formatCoin(this.cvConfigurationService.isCxOne, value) + ") " : " ";
    return resultRev;
  }

  formatPinnedValue(columnName: 'coin' | 'badge', value: number): string {
    const getLabel = (key: string, fallback: string) => this.gamesService.getGamesHistoryMessages(key, fallback);

    switch (columnName) {
      case 'coin': {
        const coinValue = formatCoin(this.cvConfigurationService.isCxOne, value);
        const reversion = this.displayReversionValue(this.revertedCoins);
        const label = this.cvConfigurationService.isCxOne ? '' : ` ${getLabel('Coins', 'Coins')}`;
        return `${coinValue}${reversion}${label}`;
      }
      case 'badge': {
        const badgeValue = value ?? 0;
        const formattedBadgeValue = badgeValue.toLocaleString(CVCultureName);
        return this.cvConfigurationService.isCxOne ? `${badgeValue === 0 ? '---' : formattedBadgeValue}` : `${formattedBadgeValue}`;
      }
      default:
        return '';
    }
  }
}
